/**
 * Collection PLP — Show More / Show Less for expanded description content.
 */
(function () {
  const SELECTOR_TOGGLE = '.collection-plp-seo__toggle';
  const SELECTOR_EXPANDED = '.collection-plp-seo__expanded';

  function initToggle(toggle) {
    const controlsId = toggle.getAttribute('aria-controls');
    if (!controlsId) return;

    const expanded = document.getElementById(controlsId);
    if (!expanded) return;

    const showMore = toggle.dataset.showMore || 'Show More';
    const showLess = toggle.dataset.showLess || 'Show Less';

    toggle.addEventListener('click', () => {
      const isHidden = expanded.hasAttribute('hidden');
      if (isHidden) {
        expanded.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.textContent = showLess;
      } else {
        expanded.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.textContent = showMore;
        toggle.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    });
  }

  function init() {
    document.querySelectorAll(SELECTOR_TOGGLE).forEach(initToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
